import type { IPropertyFact } from 'src/services/api/properties/types';

export type IStringPropertyFact = IPropertyFact & { value: string };
export type IBooleanPropertyFact = IPropertyFact & { value: boolean };
export type IStringListPropertyFact = IPropertyFact & { value: string[] };

// what the facts API accepts as a value; facts of any other shape are read-only here
export type PropertyFactValue = string | boolean | string[];

export const isStringPropertyFact = (fact: IPropertyFact): fact is IStringPropertyFact =>
    typeof fact.value === 'string';

export const isBooleanPropertyFact = (fact: IPropertyFact): fact is IBooleanPropertyFact =>
    typeof fact.value === 'boolean';

export const isStringListPropertyFact = (fact: IPropertyFact): fact is IStringListPropertyFact =>
    Array.isArray(fact.value) && fact.value.every((entry) => typeof entry === 'string');
